<template>
  <div class="multiCloudClusterDetail_container">
    <div class="multiCloudClusterDetail_container-head base-background__white base-flex__cross-center">
      <el-button class="base-font-size__24px" icon="el-icon-back" type="text" @click="back"></el-button>
      <span class="base-margin__left-8">{{ $t('multiCloudCluster.multiCloudClusterDetail.partitionList') }}</span>
      <span class="base-margin__right-5 base-margin__left-8">/</span>
      <span>{{ this.$route.query.name }}</span>
    </div>
    <el-tabs v-model="activeName" @tab-click="tabClick" class="multiCloudClusterDetail-tab">
      <el-tab-pane :label="$t('multiCloudCluster.multiCloudClusterDetail.instanceList')" name="detail">
        <div class="base-flex__between" v-if="activeName==='detail'">
          <div>
            <el-button
              v-if="disabledAddInstance"
              type="primary"
              @click="showAddInstanceDialog"
            >{{ $t('customCluster.manage.addInstance') }}
            </el-button>
            <el-button class="base-margin__bottom-10" @click="openImportDialog">
              {{ $t('multiCloudCluster.multiCloudClusterDetail.importCloudResources') }}
            </el-button>
            <el-button :disabled="instanceListSelectionChangeList.length === 0"
                       class="base-margin__bottom-10" @click="terminateInstance(instanceListSelectionChangeList)">
              {{ $t('multiCloudCluster.multiCloudClusterDetail.batchTerminate') }}
            </el-button>
            <el-button :disabled="instanceListSelectionChangeList.length === 0"
                       class="base-margin__bottom-10" @click="removeInstance(instanceListSelectionChangeList)">
              {{ $t('multiCloudCluster.multiCloudClusterDetail.batchRemove') }}
            </el-button>
          </div>
          <el-button
            class="refresh base-text-align__right"
            icon="el-icon-refresh"
            :title="$t('common.refresh')"
            type="text"
            @click="describeMultiCloudPartitionInstances"
          ></el-button>
        </div>
        <div class="table_box">
          <el-table v-loading="instanceListLoading" :data="instanceList" class="table"
                    @selection-change="instanceListSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.instanceId')">
              <template slot-scope="scope">
                <span class="base-color__light_blue base-cursor__pointer"
                      @click="openInstanceDetailsDrawer(scope.row)">{{ scope.row.instanceId }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.hostname')"
                             prop="instanceName"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.publicPrivateIP')" prop="publicIP">
              <template slot-scope="scope">
                <span>{{ scope.row.publicIP || '-' }}</span><br/>
                <span>{{ scope.row.privateIP || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.cloudProvider')">
              <template>
                <div class="provider_div base-flex__cross-center">
                  <img v-if="this.$route.query.type === 'aliyun'" src="@/views/multiCloudCluster/image/aliyun.svg"/>
                  <img v-else-if="this.$route.query.type === 'huaweicloud'"
                       src="@/views/multiCloudCluster/image/huawei.svg"/>
                  <img v-else-if="this.$route.query.type === 'volcengine'"
                       src="@/views/multiCloudCluster/image/volcengine.svg"/>
                  <span class="base-margin__left-8">{{ filterProviderList(this.$route.query.type) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.status')"
                             prop="status"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.privateNetwork')"
                             prop="vpcId"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.region')"
                             prop="Zone"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.imageId')"
                             prop="image"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.createTime')" prop="createAt">
              <template slot-scope="scope">
                {{ dayjs(scope.row.createAt).format('YYYY-MM-DD HH:mm:ss') || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.actions')">
              <template slot-scope="scope">
                <el-button size="small" type="text"
                           @click="terminateInstance([scope.row.instanceId])">
                  {{ $t('common.terminate') }}
                </el-button>
                <el-button size="small" type="text"
                           @click="removeInstance([scope.row.instanceId])">
                  {{ $t('multiCloudCluster.multiCloudClusterDetail.remove') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="instanceCurrentPage"
            :page-size="10"
            :page-sizes="[10, 20, 50, 100]"
            :total="instanceTotal"
            align="right"
            class="base-margin__top-10"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="instanceSizeChange"
            @current-change="instanceCurrentChange">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('customCluster.customDetail.baseInfo')" name="baseInfo">
        <base-info v-if="activeName==='baseInfo'"/>
      </el-tab-pane>

      <el-tab-pane :label="$t('multiCloudCluster.multiCloudClusterDetail.monitor')" name="monitor">
        <multiCloudMonitor v-if="activeName === 'monitor'" monitorType='all'></multiCloudMonitor>
      </el-tab-pane>

      <el-tab-pane :label="$t('customCluster.customDetail.ipHostname')" name="previewIP">
        <previewIP v-if="activeName==='previewIP'"/>
      </el-tab-pane>

    </el-tabs>

    <!-- 导入云资源弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="$t('multiCloudCluster.multiCloudClusterDetail.importCloudResources')" :visible.sync="ImportCloudDialogVisible"
               class="importantDialog" width="1200px"
               @close="closeImportDialog">
      <div v-loading="isGetInstances">
        <div class="base-flex base-margin__bottom-5">
          <el-select v-model="instanceStatus" :placeholder="$t('multiCloudCluster.multiCloudClusterDetail.selectStatus')" class="base-width__120 base-margin__right-10"
                     clearable
                     @change="describeInstances('normal')">
            <el-option v-for="item in instanceStatusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
          <el-input v-model="instanceName" :placeholder="$t('multiCloudCluster.multiCloudClusterDetail.inputInstanceName')"
                    class="base-width__170 base-margin__right-10"
                    @change="describeInstances('normal')"></el-input>
          <el-input v-model="instanceIds" :placeholder="$t('multiCloudCluster.multiCloudClusterDetail.inputInstanceIds')"
                    class="base-width__300 base-margin__right-10"
                    @change="describeInstances('normal')"></el-input>
        </div>
        <div class="importantDialog_table">
          <el-table :data="cloudResourcesData" @selection-change="handleSelectionChange">
            <el-table-column :selectable="checkSelectable" type="selection" width="55"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.instanceNameId')">
              <template slot-scope="scope">
                {{ scope.row.instanceName }}
                <br/>/<br/>
                {{ scope.row.instanceId }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.publicIP')" prop="publicIP">
              <template slot-scope="scope">
                {{ scope.row.publicIP || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.status')"
                             prop="status"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.privateNetwork')"
                             prop="vpcId"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.region')"
                             prop="Zone"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.imageId')"
                             prop="image"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.osName')" prop="osName"
                             width="80"></el-table-column>
            <el-table-column :label="$t('multiCloudCluster.multiCloudClusterDetail.createTime')" width="150">
              <template slot-scope="scope">
                <span>{{ disposeTime(scope.row.createAt) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ImportCloudDialogVisible = false">{{
            $t('multiCloudCluster.multiCloudClusterDetail.cancel')
          }}</el-button>
        <el-button :disabled="instanceIdList.length === 0" type="primary" @click="ImportMultiCloudPartitionInstances">{{
            $t('multiCloudCluster.multiCloudClusterDetail.confirm')
          }}</el-button>
      </span>
    </el-dialog>

    <!--实例详情 弹窗-->
    <instanceDetails ref="instanceDetails"></instanceDetails>

    <!--新增实例 弹窗-->
    <addInstanceDialog ref="addInstanceDialog" :describeMultiCloudPartitionInstances="describeMultiCloudPartitionInstances"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { postRequest } from '@/common/libs/request';
import dayjs from 'dayjs';
import { aliyunStatusList, huaweiCloudStatusList, volcengineStatusList } from '@/common/constants';
import multiCloudMonitor from './components/monitor/echartsBox.vue';
import { debounce, filterProviderList } from '@/common/utils/utils';
import instanceDetails from './components/instanceDetails/Index.vue';
import addInstanceDialog from './components/addInstance';
import previewIP from './components/previewIP';
import baseInfo from './components/baseInfo';
export default {
  name: 'multiCloudClusterDetail',
  components: {
    multiCloudMonitor,
    InstanceDetails: instanceDetails,
    addInstanceDialog,
    previewIP,
    baseInfo,
  },
  data() {
    return {
      projectId: 0,
      activeName: 'detail',
      multiCloudPartitionId: 0,
      multiCloudPartitionType: '',
      ImportCloudDialogVisible: false,
      cloudResourcesData: [],
      instanceIdList: [],
      isGetInstances: false,
      instanceList: [],
      instanceCurrentPage: 1,
      instanceTotal: 0,
      instanceLimit: 10,
      instanceStatus: '',
      instanceStatusList: [],
      nextToken: '',
      instanceName: '',
      instanceIds: '',
      vpcNextToken: '',
      marker: '',
      instanceListLoading: false,
      AliyunPageNumber: 1,
      dayjs,
      filterProviderList,
      instanceListSelectionChangeList: [],
      multicloudWhiteList: sessionStorage.getItem('multicloudWhiteList')?.split(',') || [],
      userId: sessionStorage.getItem('userId')?.toString() || '',
      disabledAddInstance: (sessionStorage.getItem('multicloudWhiteList')?.split(',') || []).includes(sessionStorage.getItem('userId')?.toString() || ''),
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.$router.push('multiCloudCluster');
      }
    },
  },
  mounted() {
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.multiCloudPartitionId = Number(this.$route.query.id);
    this.multiCloudPartitionType = this.$route.query.type;
    if (this.multiCloudPartitionType === 'volcengine') {
      this.instanceStatusList = volcengineStatusList;
    } else if (this.multiCloudPartitionType === 'huaweicloud') {
      this.instanceStatusList = huaweiCloudStatusList;
    } else if (this.multiCloudPartitionType === 'aliyun') {
      this.instanceStatusList = aliyunStatusList;
    }
    this.describeMultiCloudPartitionInstances();
    this.updateDisabledAddInstance();

    // 监听sessionStorage变化
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    tabClick(val) {
      if (val.name === 'detail') {
        this.describeMultiCloudPartitionInstances();
        this.$nextTick(() => {
          this.disabledAddInstance = this.multicloudWhiteList.includes(this.userId);
        });
      }
    },

    // 打开新增实例弹窗
    showAddInstanceDialog() {
      this.$refs.addInstanceDialog.dialogVisible = true;
    },

    /**
     * 格式化时间显示
     * @param {Number} val - 时间戳
     * @returns {String} 格式化后的时间字符串
     */
    disposeTime(val) {
      return dayjs(val).format('YYYY-MM-DD hh:mm:ss');
    },
    /**
     * 批量移除实例
     * @param val 实例信息
     * */
    instanceListSelectionChange(val) {
      this.instanceListSelectionChangeList = val.map(item => item.instanceId);
    },
    /**
     * 打开实例详情抽屉
     * @param instanceInfo 实例信息
     * */
    openInstanceDetailsDrawer(instanceInfo) {
      this.$refs.instanceDetails.openInstanceDetailsDrawer(instanceInfo);
    },

    // 返回分区
    back() {
      this.$router.push('multiCloudCluster');
    },

    // 打开导入云资源框
    openImportDialog() {
      this.ImportCloudDialogVisible = true;
      this.describeInstances('normal');
      // this.describeVpcs('normal');
      // this.describeZones();
      this.$nextTick(() => {
        const importantDialog = document.querySelector('.importantDialog_table');
        importantDialog.addEventListener('scroll', this.importantDialogScroll);
      });
    },

    importantDialogScroll() {
      debounce(() => {
        const importantDialog = document.querySelector('.importantDialog_table');
        if (importantDialog.scrollHeight === importantDialog.scrollTop + importantDialog.clientHeight && !this.isGetInstances) {
          if (this.nextToken !== '' || this.marker) {
            importantDialog.scrollTo({ top: importantDialog.scrollTop - 10 });
          }
          this.describeInstances('scroll');
        }
      }, 500);
    },

    // 查询实例
    describeInstances(type) {
      if (this.multiCloudPartitionType === 'volcengine') {
        this.describeVolcengineInstances(type);
      } else if (this.multiCloudPartitionType === 'huaweicloud') {
        this.describeHuaweiInstances(type);
      } else if (this.multiCloudPartitionType === 'aliyun') {
        this.describeAliyunInstances(type);
      }
    },

    // 查询火山云实例
    describeVolcengineInstances(type) {
      if (type === 'scroll' && this.nextToken === '') {
        return;
      }
      const data = {
        multiCloudPartitionId: this.multiCloudPartitionId,
        maxResults: 10,
      };
      if (this.instanceStatus) {
        data.status = this.instanceStatus;
      }
      if (this.nextToken && type === 'scroll') {
        data.nextToken = this.nextToken;
      }
      if (this.instanceName) {
        data.instanceName = this.instanceName;
      }
      if (this.instanceIds) {
        data.instanceIds = this.instanceIds.split('|');
      }
      this.isGetInstances = true;
      postRequest('/api/eda/common/volcengine/describeInstances', data).then((res) => {
        if (type === 'scroll') {
          this.cloudResourcesData = this.cloudResourcesData.concat(res.instanceInfoList);
        } else {
          this.cloudResourcesData = res.instanceInfoList;
        }
        this.nextToken = res.nextToken;
        this.isGetInstances = false;
      })
        .catch(() => {
          this.isGetInstances = false;
        });
    },

    // 查询华为云实例
    describeHuaweiInstances(type) {
      if (type === 'scroll' && !this.marker) {
        return;
      }
      const data = {
        multiCloudPartitionId: this.multiCloudPartitionId,
        limit: 10,
      };
      if (this.instanceStatus) {
        data.status = this.instanceStatus;
      }
      if (this.instanceName) {
        data.instanceName = this.instanceName;
      }
      if (this.instanceIds) {
        data.instanceIds = this.instanceIds.split('|');
      }
      if (this.marker && type === 'scroll') {
        data.marker = this.marker;
      }
      this.isGetInstances = true;
      postRequest('/api/eda/common/huaweicloud/describeInstances', data).then((res) => {
        if (type === 'scroll') {
          if (res.instanceInfoList) {
            this.cloudResourcesData = this.cloudResourcesData.concat(res.instanceInfoList);
          }
        } else {
          this.cloudResourcesData = res.instanceInfoList;
        }
        this.marker = res.nextToken;
        this.isGetInstances = false;
      })
        .catch(() => {
          this.isGetInstances = false;
        });
    },

    // 查询阿里云实例
    describeAliyunInstances(type) {
      if (type === 'scroll' && !this.nextToken) {
        return;
      }
      const data = {
        multiCloudPartitionId: this.multiCloudPartitionId,
        maxResults: 10,
      };
      if (this.instanceStatus) {
        data.status = this.instanceStatus;
      }
      if (this.instanceName) {
        data.instanceName = this.instanceName;
      }
      if (this.instanceIds) {
        data.instanceIds = this.instanceIds.split('|');
      }
      if (this.nextToken && type === 'scroll') {
        data.nextToken = this.nextToken;
      }
      this.isGetInstances = true;
      postRequest('/api/eda/common/aliyun/describeInstances', data).then((res) => {
        if (type === 'scroll') {
          this.cloudResourcesData = this.cloudResourcesData.concat(res.instanceInfoList);
        } else {
          this.cloudResourcesData = res.instanceInfoList;
        }
        this.nextToken = res.nextToken;
        this.isGetInstances = false;
      })
        .catch(() => {
          this.isGetInstances = false;
        });
    },

    // 导入云资源
    ImportMultiCloudPartitionInstances() {
      const data = {
        multiCloudPartitionId: this.multiCloudPartitionId,
        instanceIdList: this.instanceIdList,
      };
      postRequest('/api/eda/common/multicloud/ImportMultiCloudPartitionInstances', data).then(() => {
        this.$message.success(this.$t('multiCloudCluster.multiCloudClusterDetail.importSuccess'));
        this.ImportCloudDialogVisible = false;
        this.describeMultiCloudPartitionInstances();
      });
    },

    // 云资源选择
    handleSelectionChange(val) {
      this.instanceIdList = [];
      val.forEach((item) => {
        if (this.multiCloudPartitionType === 'volcengine') {
          this.instanceIdList.push(item.instanceId);
        }
        if (this.multiCloudPartitionType === 'aliyun') {
          this.instanceIdList.push(item.instanceId);
        }
        if (this.multiCloudPartitionType === 'huaweicloud') {
          this.instanceIdList.push(item.instanceId);
        }
      });
    },

    // 查询实例列表
    describeMultiCloudPartitionInstances() {
      this.instanceListLoading = true;
      const offset = this.instanceLimit * (this.instanceCurrentPage - 1);
      const data = {
        multiCloudPartitionId: this.multiCloudPartitionId,
        offset,
        limit: this.instanceLimit,
      };
      postRequest('/api/eda/common/multicloud/describeMultiCloudPartitionInstances', data).then((res) => {
        this.instanceList = res.instanceIdList;
        this.instanceTotal = res.totalCount;
        this.instanceListLoading = false;
      })
        .catch(() => {
          this.instanceListLoading = false;
        });
    },

    // 分页器每页条数改变
    instanceSizeChange(limit) {
      this.instanceCurrentPage = 1;
      this.instanceLimit = limit;
      this.describeMultiCloudPartitionInstances();
    },

    // 分页器当前页改变
    instanceCurrentChange(currentPage) {
      this.instanceCurrentPage = currentPage;
      this.describeMultiCloudPartitionInstances();
    },

    // 关闭导入弹窗
    closeImportDialog() {
      this.cloudResourcesData = [];
      this.nextToken = '';
      this.vpcNextToken = '';
      this.marker = '';
      const importantDialog = document.querySelector('.importantDialog_table');
      importantDialog.removeEventListener('scroll', this.importantDialogScroll);
    },

    /**
     *  销毁实例
     *  */
    terminateInstance(list) {
      this.$confirm(this.$t('multiCloudCluster.multiCloudClusterDetail.confirmTerminateInstance'), this.$t('multiCloudCluster.multiCloudClusterDetail.terminateInstance'), {
        confirmButtonText: this.$t('multiCloudCluster.multiCloudClusterDetail.confirm'),
      }).then(() => {
        const data = {
          multiCloudPartitionId: this.multiCloudPartitionId,
          multiCloudPartitionInstanceIds: list,
          force: true,
        };
        postRequest('/api/eda/common/multicloud/deleteInstances', data).then(() => {
          this.$message.success(this.$t('multiCloudCluster.multiCloudClusterDetail.terminateSuccess'));
          this.describeMultiCloudPartitionInstances();
        });
      })
        .catch(() => {
        });
    },

    /**
     *  移除实例
     *  */
    removeInstance(list) {
      this.$confirm(this.$t('multiCloudCluster.multiCloudClusterDetail.confirmRemoveInstance'), this.$t('multiCloudCluster.multiCloudClusterDetail.removeInstance'), {
        confirmButtonText: this.$t('multiCloudCluster.multiCloudClusterDetail.confirm'),
      }).then(() => {
        const data = {
          multiCloudPartitionId: this.multiCloudPartitionId,
          multiCloudPartitionInstanceIds: list,
        };
        postRequest('/api/eda/common/multicloud/DeleteMultiCloudPartitionInstances', data).then(() => {
          this.$message.success(this.$t('multiCloudCluster.multiCloudClusterDetail.removeSuccess'));
          this.describeMultiCloudPartitionInstances();
        });
      })
        .catch(() => {
        });
    },

    // 是否可以选择  table 的 checkbox
    checkSelectable(row) {
      return row.multiCloudPartitionInstanceId === 0;
    },

    // 更新disabledAddInstance状态
    updateDisabledAddInstance() {
      this.multicloudWhiteList = sessionStorage.getItem('multicloudWhiteList')?.split(',') || [];
      this.userId = sessionStorage.getItem('userId')?.toString() || '';
      this.disabledAddInstance = this.multicloudWhiteList.includes(this.userId);
    },

    // 处理sessionStorage变化
    handleStorageChange(event) {
      if (event.key === 'multicloudWhiteList' || event.key === 'userId') {
        this.updateDisabledAddInstance();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.multiCloudClusterDetail_container {
  height: calc(100% - 8px);

  .multiCloudClusterDetail_container-head {
    font-size: 14px;
    padding: 0 20px;
  }
}

// table 背景颜色+padding10px
.table_box {
  background: #fff;
  padding: 10px;
  height: calc(100% - 52px);

  .table {
    height: calc(100% - 52px);

    ::v-deep .el-table__body-wrapper {
      height: calc(100% - 52px);
      overflow-y: auto;
    }
  }

  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.multiCloudClusterDetail-tab {
  height: calc(100% - 41px);

  ::v-deep .el-tabs__header {
    padding: 0 20px;
    background: #fff;
  }

  ::v-deep .el-tabs__content {
    height: calc(100% - 55px);
    margin: 0 20px;
  }

  ::v-deep .el-table {
    .el-table__body-wrapper {
      overflow-y: auto !important;
    }
  }

  .el-tab-pane {
    height: 100%;
  }
}

.importantDialog {

  .importantDialog_table {
    max-height: 400px;
    overflow-y: auto;
  }

  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
}

.provider_div {
  img {
    width: 14px;
    height: 14px;
  }
}

.refresh {
  font-size: 20px;
  margin-right: 10px;
}
</style>
